import type { CSSProperties } from 'react'

// Props for an element that fades up when it scrolls into view (see the reveal styles in globals.css).
export const reveal = (delayMs = 0): { 'data-reveal': string, style?: CSSProperties } => {
    if (delayMs <= 0) return { 'data-reveal': '' }

    return {
        'data-reveal': '',
        style: { '--reveal-delay': `${delayMs}ms` } as CSSProperties
    }
}
